<template>
    <div>
        <button class="slim-button profile-measurements-btn" @click="autofill" v-if="!isLoggedIn || values">
            {{ $tr.measurements.begin.profileMeasureBtn }}
        </button>
        <!--<div v-if="$db.measurements._isOutdated" class="weight-gain-box">
            {{ $tr.summary.weightGain }} {{ $db.measurements._updatedAt }}
        </div>-->
        <Modal v-model="loginModalVisible" :loading="loginModalLoading">
            <form @submit.prevent="login">
                <h3 class="thin">
                    {{ $tr.measurements.begin.profileMeasureLoginModal.title }}
                </h3>

                <label>
                    <span>{{ $tr.measurements.begin.profileMeasureLoginModal.email }}:</span>
                    <input type="email" v-model="loginData.email">
                </label>

                <label>
                    <span>{{ $tr.measurements.begin.profileMeasureLoginModal.password }}:</span>
                    <input type="password" v-model="loginData.password">
                </label>

                <div class="mb-2">
                    <!-- Go to first product that is not selected -->
                    <Button type="success" el-type="submit" size="centered" class="text-center">
                        {{ $tr.measurements.begin.profileMeasureLoginModal.login }}
                    </Button>
                </div>
                <div>
                    <a :href="$backendConfig.api['forgotPassword']" target="_blank">
                        {{ $tr.measurements.begin.profileMeasureLoginModal.resetPassword }}
                    </a>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import Modal from "../common/Modal";
import Button from "../common/Button";
import {EventBus} from "../../event-bus";

export default {
    name: "AutofillMeasurements",
    components: {Button, Modal},
    props: [
        "type"
    ],
    data() {
        return {
            loginModalVisible: false,
            loginModalLoading: false,
            loginData: {
                email: null,
                password: null
            }
        };
    },
    computed: {
        isLoggedIn() {
            return !!this.$defaultMeasurements.value;
        },
        values() {
            return this.$defaultMeasurements.value[this.type];
        }
    },
    methods: {
        autofill() {
            // Autofill not available -> show login modal
            if (!this.isLoggedIn)
                return this.loginModalVisible = true;

            this.$set(this.$db, "measurements", this.values);
        },
        login() {
            this.loginModalLoading = true;

            this.$api("autofillLogin", this.loginData)
                .then(data => {
                    data = data.data;
                    if (data.autofill) {                                // Autofill
                        this.$set(this.$defaultMeasurements, "value", data.autofill);
                        this.loginModalVisible = false;
                        this.autofill();
                    } else if (typeof data.autofill === "object") {    // No autofill available
                        this.$set(this.$defaultMeasurements, "value", {
                            shirt: null,
                            body: null,
                        });
                        this.loginModalVisible = false;
                        EventBus.$emit("flash-message", this.$tr.measurements.begin.profileMeasureLoginModal.noAutofill, "error");
                    } else {                         // Login failed
                        EventBus.$emit("flash-message", this.$tr.measurements.begin.profileMeasureLoginModal.failed, "error");
                        this.loginData.password = null;
                    }
                })
                .catch(() => {
                    EventBus.$emit("flash-message", this.$tr.measurements.begin.profileMeasureLoginModal.failed, "error");
                })
                .finally(() => {
                    this.loginModalLoading = false;
                });
        }
    }
}
</script>
